// extracted by mini-css-extract-plugin
export default {"main":"charts_main__wP1nz","title":"charts_title__4MZp3","divider":"charts_divider__TTY5f","chart":"charts_chart__2kM5j"};